import React from 'react'
import ReactQuill from 'react-quill'
import EmojiPicker from 'emoji-picker-react'
import Tooltip from '@material-ui/core/Tooltip'
import Typography from '@material-ui/core/Typography'
import InfoIcon from '@material-ui/icons/Info'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import ExpandLessIcon from '@material-ui/icons/ExpandLess'
import 'react-quill/dist/quill.snow.css'
import './styles.css'
import {
  BoldIcon,
  CodeIcon,
  ItalycIcon,
  SmileIcon,
  StrikeIcon,
} from '../../../source/icons-svg'

// Modules object for setting up the Quill editor
const modules = {
  toolbar: [],
}

// // Formats objects for setting up the Quill editor
const formats = []

class EditorMessage extends React.Component {
  constructor(props) {
    super(props)
    this.state = { showEmoji: false }
    this.quillRef = null
    this.reactQuillRef = null
    this.addParam = this.addParam.bind(this)
    this.addEmoji = this.addEmoji.bind(this)
    this.setShowEmoji = this.setShowEmoji.bind(this)
    this.formatBold = this.formatBold.bind(this)
    this.formatItalic = this.formatItalic.bind(this)
    this.formatStrike = this.formatStrike.bind(this)
    this.formatCode = this.formatCode.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.setEditorHtml = this.setEditorHtml.bind(this)
  }

  addParam() {
    if (this.reactQuillRef) {
      let params = this.props.paramSize
      params = parseInt(params) + 1
      const quill = this.reactQuillRef.getEditor()
      quill.focus()
      const range = quill.getSelection()
      if (range) {
        quill.insertText(range.index, ` {{${params}}} `)
        const newValue = quill.getText(0, quill.getLength())
        this.props.setParamSize(params, newValue)
      }
    }
  }

  addEmoji(emoji) {
    if (this.reactQuillRef) {
      const quill = this.reactQuillRef.getEditor()
      quill.focus()
      const range = quill.getSelection()
      if (range) {
        quill.insertText(range.index, emoji)
      }
    }
  }

  formatBold() {
    if (this.reactQuillRef) {
      const quill = this.reactQuillRef.getEditor()
      const range = quill.getSelection()
      if (range) {
        if (range.length) {
          const text = quill.getText(range.index, range.length)
          const indexEnd = text.length - 1
          if (text.trim().length) {
            let newText = '*' + text.trim() + '*'
            if (text[0] === '*' && text[indexEnd] === '*') {
              newText = text.substring(1, indexEnd)
            }
            quill.deleteText(range.index, range.length)
            quill.insertText(range.index, newText)
            const newValue = quill.getText(0, quill.getLength())
            this.props.onChange(newValue)
          }
        }
      }
    }
  }

  formatItalic() {
    if (this.reactQuillRef) {
      const quill = this.reactQuillRef.getEditor()
      const range = quill.getSelection()
      if (range) {
        if (range.length) {
          const text = quill.getText(range.index, range.length)
          const indexEnd = text.length - 1
          if (text.trim().length) {
            let newText = '_' + text.trim() + '_'
            if (text[0] === '_' && text[indexEnd] === '_') {
              newText = text.substring(1, indexEnd)
            }
            quill.deleteText(range.index, range.length)
            quill.insertText(range.index, newText)
            const newValue = quill.getText(0, quill.getLength())
            this.props.onChange(newValue)
          }
        }
      }
    }
  }

  formatStrike() {
    if (this.reactQuillRef) {
      const quill = this.reactQuillRef.getEditor()
      const range = quill.getSelection()
      if (range) {
        if (range.length) {
          const text = quill.getText(range.index, range.length)
          const indexEnd = text.length - 1
          if (text.trim().length) {
            let newText = '~' + text.trim() + '~'
            if (text[0] === '~' && text[indexEnd] === '~') {
              newText = text.substring(1, indexEnd)
            }
            quill.deleteText(range.index, range.length)
            quill.insertText(range.index, newText)
            const newValue = quill.getText(0, quill.getLength())
            this.props.onChange(newValue)
          }
        }
      }
    }
  }

  formatCode() {
    if (this.reactQuillRef) {
      const quill = this.reactQuillRef.getEditor()
      const range = quill.getSelection()
      if (range) {
        if (range.length) {
          const text = quill.getText(range.index, range.length)
          const indexEnd = text.length - 1
          if (text.trim().length) {
            let newText = '```' + text.trim() + '```'
            if (text.length > 6) {
              const firstThree = text.substring(0, 3)
              const endThree = text.substring(indexEnd - 2)
              if (firstThree === '```' && endThree === '```') {
                newText = text.substring(3, indexEnd - 2)
              }
            }
            quill.deleteText(range.index, range.length)
            quill.insertText(range.index, newText)
            const newValue = quill.getText(0, quill.getLength())
            this.props.onChange(newValue)
          }
        }
      }
    }
  }

  setShowEmoji(isShow) {
    this.setState({ showEmoji: isShow })
  }

  checkparam(indexs, value, editorHtml, counterParam) {
    var value = value
    var content = editorHtml
    let stringcheck = ''
    let stringIndex = ''
    let index = 0
    for (let i = indexs; i < value.length; i++) {
      if (value[i] == '{' && value[i + 1] == '{') {
        index = value.indexOf('}', i)
        if (value[index + 1] == '}') {
          stringIndex = value.substring(i, index + 2)
          stringcheck = stringIndex.substring(2, stringIndex.length - 2)
          if (
            parseInt(stringcheck) > 0 &&
            parseInt(stringcheck) > counterParam
          ) {
            content = content.replaceAll('' + stringIndex + '', '')
            stringIndex = ''
            let stringfirst = value.substr(0, i - 1)
            let stringend = value.substr(index + 2, value.length)
            value = stringfirst + stringIndex + stringend + ' '
            this.handleChange(content)
          }
        }
      }
    }
  }

  setEditorHtml(value) {
    if (!value.length) return ''
    if (!value.includes('\n')) return '<p>' + value + '</p>'
    if (value.length === 1 && value[0] === '\n') {
      return '<p><br></p>'
    }

    let editorHtml = ''

    for (let i = 0; i < value.length; i++) {
      if (value[i] === '\n') {
        if (i === 0) {
          // first
          if (value[i + 1] === '\n') {
            editorHtml += '<p><br></p>'
          } else {
            editorHtml += '<p><br></p>' + '<p>'
          }
        } else if (i === value.length - 1) {
          //end
          if (value[i - 1] === '\n') {
            editorHtml += '<p><br></p>'
          } else {
            editorHtml += '</p><p><br></p>'
          }
        } else {
          //center
          if (value[i - 1] === '\n' && value[i + 1] === '\n') {
            editorHtml += '<p><br></p>'
          } else if (value[i - 1] === '\n' && value[i + 1] !== '\n') {
            editorHtml += '<p>'
          } else if (value[i - 1] !== '\n' && value[i + 1] === '\n') {
            editorHtml += '</p>'
          } else {
            editorHtml += '</p><p>'
          }
        }
      } else {
        if (i === 0) {
          // first
          editorHtml += '<p>' + value[i]
        } else if (i === value.length - 1) {
          //end
          editorHtml += value[i] + '</p>'
        } else {
          //center
          editorHtml += value[i]
        }
      }
    }
    return editorHtml
  }

  handleChange = (content) => {
    const { onChange, setParamSize, maxLength } = this.props
    var value = content
    var regex = /[^0-9]/g
    var falseParam = 1
    let stringcheck = ''
    let stringIndex = ''
    let index = 0
    let temp = 0
    let tempstr = []
    let strchange = ''
    let counterbod = 0

    value = value.replaceAll('</p><p>', '\n');
    value = value.replaceAll('<p>', '');
    value = value.replaceAll('</p>', '');
    value = value.replaceAll('<br>', '');
    value = value.replaceAll('&amp;', '&');
    value = value.replaceAll('&lt;', '<');
    value = value.replaceAll('&gt;', '>');
    value = value.replaceAll('&nbsp;', ' ');
    value = value.replaceAll('&rdquo;', '"');

    if (value === '\n') {
      onChange('', content)
    } else {
      onChange(value, content)
    }

    for (let i = 0; i < value.length; i++) {
      if (value[i] == '{' && value[i + 1] == '{') {
        index = value.indexOf('}', i)
        if (value[index + 1] != '}') {
          this.checkparam(index, value, content, counterbod)
          falseParam = 1
          break
        } else {
          stringIndex = value.substring(i, index + 2)
          stringcheck = stringIndex.substring(2, stringIndex.length - 2)
          if (stringcheck.match(regex) == null && stringcheck != '') {
            counterbod += 1
            let maxvalue = Math.max(...tempstr)
            if (maxvalue == -Infinity) maxvalue = 0
            if (
              parseInt(stringcheck) > 0 &&
              !(parseInt(stringcheck) > maxvalue + 1)
            ) {
              falseParam = 0
              temp = parseInt(stringcheck)
              if (tempstr.indexOf(stringcheck) == -1) {
                tempstr.push(stringcheck)
              } else {
                counterbod -= 1
              }
            } else {
              content = content.replaceAll('' + stringIndex + '', '')
              stringIndex = ''
              let stringfirst = value.substr(0, i - 1)
              let stringend = value.substr(index + 2, value.length)
              value = stringfirst + stringIndex + stringend + ' '
              counterbod -= 1
              this.handleChange(content)
            }
          } else {
            falseParam = 1
            this.checkparam(index, value, content, counterbod)
            break
          }
        }
      } else if (value[i] == '{' && value[i + 1] != '{' && i > index + 1) {
        index = value.indexOf('}', i)
        this.checkparam(index, value, content, counterbod)
        falseParam = 1
        break
      } else {
        continue
      }
    }

    setParamSize(counterbod)

    const limitLength = maxLength || 1024

    if (value.length > limitLength) {
      value = value.substr(0, limitLength)
      this.handleChange(this.setEditorHtml(value))
    }
  }

  render() {
    const { value, placeholder, lengthValue, disabled, maxLength } = this.props
    const { showEmoji } = this.state
    const btnDisabled = lengthValue >= 1023 || disabled
    const limitLength = maxLength || 1024

    return (
      <div>
        {showEmoji && (
          <div className="emoji">
            <EmojiPicker
              height={400}
              autoFocusSearch={false}
              emojiStyle="facebook"
              onEmojiClick={(emoji) => {
                this.addEmoji(emoji.emoji)
              }}
            />
          </div>
        )}
        <div className={`row_btn_toolbar`}>
          <button disabled={btnDisabled} onClick={this.formatBold}>
            <BoldIcon />
          </button>
          <button disabled={btnDisabled} onClick={this.formatItalic}>
            <ItalycIcon />
          </button>
          <button disabled={btnDisabled} onClick={this.formatStrike}>
            <StrikeIcon />
          </button>
          <button
            disabled={lengthValue >= 1019 || disabled}
            onClick={this.formatCode}
            style={{ marginLeft: '5px' }}
          >
            <CodeIcon />
          </button>
        </div>

        <button
          className={`emoji_btn`}
          disabled={btnDisabled}
          onClick={() => {
            this.setShowEmoji(!showEmoji)
          }}
        >
          <SmileIcon />
          {showEmoji ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </button>
        <button
          className={`add_param_btn`}
          disabled={btnDisabled}
          onClick={this.addParam}
        >
          + Add Parameter
        </button>
        <div className={`row_info_tooltip`}>
          <div className="">{'Characters: ' + lengthValue + '/' + limitLength}</div>
          <div className="tooltip_info">
            <Tooltip
              title={
                <React.Fragment>
                  <Typography variant="h6" color="inherit">
                    This is text you specify in the API that will be personlized
                    to the customer, such as their name or invoice number
                  </Typography>
                </React.Fragment>
              }
            >
              <button>
                <i className="small_icon">
                  <InfoIcon />
                </i>
              </button>
            </Tooltip>
          </div>
        </div>
        <ReactQuill
          value={value}
          modules={modules}
          formats={formats}
          placeholder={placeholder}
          theme={'snow'}
          readOnly={disabled}
          onChange={this.handleChange}
          ref={(el) => {
            this.reactQuillRef = el
          }}
          onKeyPress={(event) => {
            if (showEmoji) this.setShowEmoji(false)
          }}
        />
      </div>
    )
  }
}

export default EditorMessage
